// extracted by mini-css-extract-plugin
var _1 = "TxHU9_jgXMosAURkD6Nz";
var _2 = "obVc_MEh7mmIYgoiRdLO";
export { _1 as "message", _2 as "title" }
